var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute left-0 bottom-0 top-0 pa4 flex flex-column justify-end"},[(_vm.navigation)?_c('NavSidebar',{ref:"navSidebar",attrs:{"brand":_vm.brand,"items":_vm.navigation,"title":_vm.title}}):_vm._e(),_c('div',[_c('Button',{attrs:{"brand":_vm.brand,"icon":_vm.icon.arrowUp,"text":"Back to top"},on:{"click":_vm.backToTop}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }